import React, { useEffect, useState } from 'react';
import { Button } from '@ui/components';
import { useReport } from './UsageReportContext';
import { minutesToHuman } from './utils';

export const ExportCSVButton: React.FC = () => {
  const { table } = useReport();
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    if (!table) {
      return;
    }

    const rows = [
      ['Windows User', 'Enscape User ID', 'CAD', 'Usage Time in Minutes', 'Usage Time'],
      ...table.map((row) => [
        row.machineName,
        row.userName,
        row.cad,
        row.durationInMinutes,
        minutesToHuman(row.durationInMinutes),
      ]),
    ];

    const csv = rows.map((r) => r.join(',')).join('\r\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));

    setDataUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [table]);

  return (
    <Button
      size='small'
      variant='outlined'
      href={dataUrl}
      download='EnscapeUsage.csv'
      disabled={!table}
    >
      Export .CSV
    </Button>
  );
};
